import type { ComponentProps } from "react";
import type { YearsDropdown } from "react-day-picker";

export type SubjectFilterItem = {
  subjectId: number;
  name: string;
};

export type DoubtsFilterState = {
  /** Selected subjects with numeric IDs (from API). Empty = no filter. */
  subjects: SubjectFilterItem[];
  /** API status values, e.g. "Dismissed", "Feedback Pending", "in Progress", "Solved". */
  status: string[];
  startDate: string;
  endDate: string;
};

export const emptyDoubtsFilterState = (): DoubtsFilterState => ({
  subjects: [],
  status: [],
  startDate: "",
  endDate: "",
});
export type FilterYearGridDropdownProps = ComponentProps<typeof YearsDropdown>;
